import React from "react";
import styled from "styled-components";

const MobileOnly = styled.div`
  margin-left: 26px;
  @media (min-width: 575px) {
    display: none;
  }
`;

const MobileClose = props => {
  return (
    <MobileOnly>
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="13.287"
        height="13.287"
        viewBox="0 0 13.287 13.287"
      >
        <g
          transform="translate(.354 .354)"
          fill="none"
          stroke="#e26a71"
          strokeMiterlimit="10"
        >
          <line x1="12.58" y1="12.58" />
          <line y1="12.58" x2="12.58" />
        </g>
      </svg>
    </MobileOnly>
  );
};

export default MobileClose;
